export default {"src":"/_next/static/media/wordpress-tile.acdd7238.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};